<template>
  <div class="labeled-compnay-branches-list">
    <InputLabel
      :input-id="inputId"
      :label="label"
      :required-icon="requiredIcon"
      :tooltip="tooltip"
    />
    <CompanyBranchesListSelector
      ref="companyBranches"
      :id="inputId"
      :placeholder="placeholder"
      :company-id="companyId"
      :disabled="isDisabled"
      :empty-state-text="emptyStateText"
      v-on="$listeners"
      v-bind="$attrs"
    >
      <slot />
    </CompanyBranchesListSelector>
  </div>
</template>

<script>
import { CompanyBranchesListSelector } from '@/features/selectors/company-branches';
import { RandomId } from '@/shared/lib/random';
import { InputLabel } from '@/shared/ui/form';

const { generateRandomId } = RandomId();

export default {
  props: {
    label: {
      type: String,
      default: 'Оберіть авто клієнта зі списку',
    },
    value: {
      type: [String, Object],
      default: null,
    },
    placeholder: {
      type: String,
      default: 'Виберіть тип документа',
    },
    requiredIcon: {
      type: Boolean,
      default: false,
    },
    tooltip: {
      type: Object,
      default: null,
    },
    companyId: {
      type: [String, Number],
      required: true,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    emptyStateText: {
      type: String,
      default: 'Нічого немає',
    },
  },
  components: { InputLabel, CompanyBranchesListSelector },
  computed: {
    inputId() {
      return `company-branches-list-${this.generateRandomId()}`;
    },
    getCompanyBranchesList() {
      return this.$refs.companyBranches;
    }
  },
  methods: {
    generateRandomId,
  },
};
</script>
